import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "SCPEMVPROFILECODE";
export const scpEmvProfileConstants = createCRUDConstants(nameSpace)